export default __webpack_public_path__ + "static/media/bag14.f78c3e5e.jfif";